import './publicationscontainer.less'
import m from 'mithril'
import {t} from 'store'
import {Component, action, classes, MediaQuery} from '@codeurs/front'
import {PublicationType} from 'views/partials/features/publicationlink'
import ContainerTitle from 'views/layout/containertitle'
import Button from 'views/layout/button'
import FeaturedPublication from './featuredpublication'
import PublicationLink from 'views/partials/features/publicationlink'
import {scrollbarWidth} from 'util/scrollbar'

export default class PublicationsContainer extends Component<{
	related: {
		publications: Array<PublicationType>
	}
	featured_publication?: PublicationType
	allTags: any
	class?: string
	mod?: string
	lists?: Array<string>
	channel?: string
}> {
	view() {
		const {
			related,
			allTags,
			featured_publication,
			class: className,
			lists,
			channel,
			mod
		} = this.attrs
		const texts = this.getText(channel)

		return (
			related.publications[0] &&
			m('.publicationscontainer', {class: className}, [
				m(MediaQuery, {
					maxWidth: 1325,
					view: () => this.viewBgContainer(mod, false)
				}),
				m(MediaQuery, {
					minWidth: 1326,
					view: () => this.viewBgContainer(mod, true)
				}),
				m('.publicationscontainer-container', [
					m('.publicationscontainer-container-inner', [
						related.publications[0] &&
							m(ContainerTitle, {
								text: texts.title,
								className: 'publicationscontainer-container-title'
							}),
						this.getPublications(related.publications, allTags)
					]),
					featured_publication &&
						featured_publication.title &&
						this.getFeaturedPublication(featured_publication)
				]),
				mod != 'publication' &&
					m(Button,
						{
							...action('/publications'),
							class: 'publicationscontainer-button',
							mod: 'more arrow'
						},
						texts.more
					)
			])
		)
	}
	viewBgContainer(mod: string, bigContainer: boolean) {
		return m('.publicationscontainer-bg', {
			...classes({mod}),
			style: bigContainer && this.getContainerStyling(mod)
		})
	}
	getContainerStyling(mod: string) {
		const scrollBarWidth = `${scrollbarWidth()}px`
		switch (mod) {
			case 'publication':
				return {
					'margin-left': `calc((100vw - ${scrollBarWidth} - 100%) / -2 + 7.5rem)`,
					width: `calc(100vw - ${scrollBarWidth} - 7.5rem )`
				}
		}
	}

	getFeaturedPublication(featured: PublicationType) {
		return m(FeaturedPublication, {
			mod: 'home',
			featured,
			channel: this.attrs.channel
		})
	}
	getPublications(publications: Array<PublicationType>, allTags: Object) {
		return publications.slice(0, 2).map(publication => {
			return m(PublicationLink, {
				tags: this.findTags(publication, allTags),
				publication
			})
		})
	}
	findTags(publication: PublicationType, allTags: Object): Array<string> {
		return publication.tags.map(tag => allTags[tag])
	}

	getText(channel: string): {title: string; more: string} {
		let texts = {
			title: t('publications.relatedpublications'),
			more: t('publications.allpublications')
		}
		switch (channel) {
			case 'homepage':
				texts.title = t('publications.latestpublications')
				texts.more = t('publications.morepublications')
		}

		return texts
	}
}
